import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorState } from '@payment-plan/ui';
import { AppShellLayout } from './AppShellLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { AdvisorsPage } from '../features/admin/advisors/AdvisorsPage';
import { CatalogPage } from '../features/admin/catalog/CatalogPage';
import { CompaniesPage } from '../features/admin/companies/CompaniesPage';
import { ProjectsPage } from '../features/admin/projects/ProjectsPage';
import { UsersPage } from '../features/admin/users/UsersPage';
import { DefinirContrasenaPage } from '../features/auth/DefinirContrasenaPage';
import { RecuperarPage } from '../features/auth/RecuperarPage';
import { AdminSeparationsPage } from '../features/consultas/AdminSeparationsPage';
import { MySeparationsPage } from '../features/consultas/MySeparationsPage';
import {
  AdminSeparationDetailPage,
  MySeparationDetailPage,
} from '../features/consultas/SeparationDetailPages';
import { EditSeparationPage } from '../features/separations/EditSeparationPage';
import { NewSeparationPage } from '../features/separations/NewSeparationPage';
import { DashboardPage } from '../features/shell/DashboardPage';
import { LoginPage } from '../features/shell/LoginPage';

function NotFoundPage(): React.JSX.Element {
  return <ErrorState title="Página no encontrada" message="La ruta solicitada no existe." />;
}

export function AppRoutes(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* fix-60: públicas, sin sesión — enlace del correo de invitación/recuperación. */}
      <Route path="/definir-contrasena" element={<DefinirContrasenaPage />} />
      <Route path="/recuperar" element={<RecuperarPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShellLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="admin/companies" element={<CompaniesPage />} />
          <Route path="admin/projects" element={<ProjectsPage />} />
          <Route path="admin/catalog" element={<CatalogPage />} />
          <Route path="admin/advisors" element={<AdvisorsPage />} />
          <Route path="admin/users" element={<UsersPage />} />
          <Route path="separations/new" element={<NewSeparationPage />} />
          <Route path="separations/:id/editar" element={<EditSeparationPage />} />
          {/* HU-WEB-006 · feat-42: consultas de separaciones y documentos */}
          <Route path="separations" element={<MySeparationsPage />} />
          <Route path="separations/:id" element={<MySeparationDetailPage />} />
          <Route path="admin/separations" element={<AdminSeparationsPage />} />
          <Route path="admin/separations/:id" element={<AdminSeparationDetailPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
